import { Route, Routes } from "react-router";

// const Overview = lazy(() => import('./pages/Overview'));
// const Subscription = lazy(() => import('./pages/Subscription'));

class Paths {
    static readonly Lms = "Lms";
    static readonly Knowledge = "Lmsknowledge";
    static readonly Performance = "Performance";
}

export class SubscriptionsPaths {
    static readonly Prefix = "/Subscriptions";
    static readonly Lms = SubscriptionsPaths + "/" + Paths.Lms;
    static readonly Knowledge = SubscriptionsPaths + "/" + Paths.Knowledge;
    static readonly Performance = SubscriptionsPaths + "/" + Paths.Performance;
}

const SubscriptionsRouter = () => {
    return (
        <Routes>
            <Route path={Paths.Lms} element={<div>Lms</div>} />
            <Route path={Paths.Knowledge} element={<div>knowledge</div>} />
            <Route path={Paths.Performance} element={<div>performance</div>} />
        </Routes>
    );
};

export default SubscriptionsRouter;
